export default function headerColor() {
    let header = document.querySelector(".main-header");

    if(document.querySelector(".page-wrapper.header-color")) {
        header.classList.add("header-color");
    }
}
